export const version = "abstract-provider/5.4.1";
//# sourceMappingURL=_version.js.map